// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2P_bA","additionalInfo":"AgreementModal_additionalInfo__2ebSr"};